var render = function render(){var _vm=this,_c=_vm._self._c;return _c('adSkeleton',{attrs:{"id-name":"adup_deals_detail_contentAd_top","placement-keys":_vm.placementKeys,"query":_vm.query,"locale":_vm.locale}})
}
var staticRenderFns = []

export { render, staticRenderFns }